import Vue from 'vue';
// 英文星期转中文星期
Vue.filter('weekToCN', (value) => {
  // 返回处理后的值
  if (typeof value !== 'string') return false;
  return value.split(',').map((item) => {
    switch (item) {
      case 'MON':
        return '周一';
      case 'TUE':
        return '周二';
      case 'WED':
        return '周三';
      case 'THU':
        return '周四';
      case 'FRI':
        return '周五';
      case 'SAT':
        return '周六';
      case 'SUN':
        return '周日';
      default:
        return '';
    }
  }).join(',');
});

// 启用 未启用 状态格式化
Vue.filter('formatStatus', (value) => {
  if (typeof value !== 'number') return false;
  return value === 1 ? '已启用' : '未启用';
});

Vue.filter('timestampFilter', (timestamp, isFull = true) => {
  let pattern = '';
  if (isFull) {
    pattern = 'yyyy-MM-dd hh:mm:ss';
  } else {
    pattern = 'yyyy-MM-dd';
  }

  let f = '';
  if (timestamp) {
    f = new Date(timestamp).format(pattern);
  }

  return f;
});



// WEBPACK FOOTER //
// ./src/utils/filter.js